/**
 * Some constants that can be used inside the moderat advisor.
 */
export class ModeratConstants {
  // maximum tim e in days until a local storage element of the advisor should be valid
  static readonly LOCALSTORAGE_TIMEOUT_DAYS = 2;

  // form inputs
  static readonly FORM_PEOPLE_MAX = 10;
  static readonly FORM_PEOPLE_DEFAULT = 2;
  static readonly FORM_WATER_TEMPERATURE_DEFAULT = 60;
  static readonly FORM_WATER_TEMPERATURE_MIN = 35;
  static readonly FORM_WATER_TEMPERATURE_MAX = 70;
  static readonly INVOICE_MIN_DAYS = 270;
  static readonly INVOICE_MAX_DAYS = 450;
  static readonly INVOICE_MIN_DAYS_IN_PAST = 1;
  static readonly FORM_FLOOR_MAX_MFH = 20;
  static readonly FORM_FLOOR_MIN_MFH = 2;
  static readonly FORM_FLOOR_MAX_EFH = 5;
  static readonly FORM_FLOOR_MIN_EFH = 1;
  static readonly FORM_SOLAR_THERMAL_BUILDING_YEAR_MIN = 1970;


  // result constants
  static readonly CO2_TREE_KG_YEAR = 12.5;

  // percentage of how much the consumption can be deviate from the default to show certain conmtent on the resultpage of second chapter
  static readonly CONSUMPTION_DEVIATION = 0.15;

}
